export default __webpack_public_path__ + "static/media/reset.c1c08596.jpg";